import { db } from "./firebase";
import { collection, addDoc } from "firebase/firestore";

const LOGO_URL = "https://woofsy.co.in/logo192.png";
const WEBSITE_URL = "https://woofsy.co.in";
const ADMIN_EMAIL = "info@woofsy.co.in";
const WHATSAPP_NUM = "918421114134";

export async function sendEmailNotification({ to, subject, html }) {
  try {
    const mailRef = collection(db, "mail");
    await addDoc(mailRef, {
      to: Array.isArray(to) ? to : [to],
      message: {
        subject,
        html,
      },
    });
    return true;
  } catch (error) {
    console.error("Failed to send email notification via Firestore:", error);
    return false;
  }
}

export function buildBookingEmailTemplate(booking, isForAdmin = false) {
  const waText = encodeURIComponent(`Hi Woofsy Team, checking status for Booking #${booking.id || 'NEW'} (${booking.pet_name})`);
  const waLink = `https://api.whatsapp.com/send/?phone=${WHATSAPP_NUM}&text=${waText}&type=phone_number&app_absent=0`;

  return `
    <div style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; background-color: #FFF8F2; padding: 20px; color: #1C2430;">
      <div style="max-width: 600px; margin: 0 auto; background: #ffffff; border-radius: 20px; overflow: hidden; box-shadow: 0 10px 25px rgba(0,0,0,0.05); border: 1px solid #FFEBE0;">
        
        <!-- Header -->
        <div style="background: linear-gradient(135deg, #FF8A3D 0%, #FF6B00 100%); padding: 24px; text-align: center; color: #ffffff;">
          <h1 style="margin: 0; font-size: 26px; font-weight: 800; letter-spacing: -0.5px;">🐾 Woofsy Pet Care</h1>
          <p style="margin: 6px 0 0 0; font-size: 14px; opacity: 0.9;">At-Home Premium Pet Grooming</p>
        </div>

        <!-- Body Content -->
        <div style="padding: 32px 24px;">
          <h2 style="color: #FF8A3D; font-size: 20px; margin-top: 0;">
            ${isForAdmin ? "🚨 New Booking Alert Received!" : "🎉 Booking Confirmation - " + booking.pet_name}
          </h2>
          <p style="font-size: 15px; line-height: 1.6; color: #4A5568;">
            ${isForAdmin 
              ? `A new grooming appointment has been booked by <b>${booking.owner_name}</b> for pet <b>${booking.pet_name}</b>.`
              : `Hi <b>${booking.owner_name}</b>, thank you for booking with Woofsy! Our professional groomer will reach your location as scheduled.`}
          </p>

          <!-- Details Card -->
          <div style="background-color: #FFF8F2; border: 1px border-slate-100; border-radius: 14px; padding: 20px; margin: 24px 0;">
            <h3 style="margin-top: 0; color: #1C2430; font-size: 16px; border-bottom: 2px solid #FFD8BE; padding-bottom: 8px;">
              📋 Appointment Details
            </h3>
            <table style="width: 100%; border-collapse: collapse; font-size: 14px;">
              <tr>
                <td style="padding: 8px 0; color: #718096; font-weight: 600;">Pet Name & Type:</td>
                <td style="padding: 8px 0; font-weight: bold; text-align: right; color: #1C2430;">${booking.pet_name} (${booking.pet_type || 'Dog'}${booking.breed ? ', ' + booking.breed : ''})</td>
              </tr>
              <tr>
                <td style="padding: 8px 0; color: #718096; font-weight: 600;">Service Booked:</td>
                <td style="padding: 8px 0; font-weight: bold; text-align: right; color: #FF8A3D;">${booking.service}</td>
              </tr>
              <tr>
                <td style="padding: 8px 0; color: #718096; font-weight: 600;">Date & Time Slot:</td>
                <td style="padding: 8px 0; font-weight: bold; text-align: right; color: #1C2430;">${booking.preferred_date} (${booking.preferred_time})</td>
              </tr>
              <tr>
                <td style="padding: 8px 0; color: #718096; font-weight: 600;">Owner Phone:</td>
                <td style="padding: 8px 0; font-weight: bold; text-align: right; color: #1C2430;">${booking.phone}</td>
              </tr>
              <tr>
                <td style="padding: 8px 0; color: #718096; font-weight: 600;">Service Address:</td>
                <td style="padding: 8px 0; font-weight: bold; text-align: right; color: #1C2430;">${booking.address}</td>
              </tr>
              <tr>
                <td style="padding: 8px 0; color: #718096; font-weight: 600;">Total Amount:</td>
                <td style="padding: 8px 0; font-weight: 800; font-size: 16px; text-align: right; color: #FF8A3D;">₹${booking.total_amount || booking.price || 1399}</td>
              </tr>
              <tr>
                <td style="padding: 8px 0; color: #718096; font-weight: 600;">Booking Status:</td>
                <td style="padding: 8px 0; font-weight: bold; text-align: right; color: #2563EB;">${booking.status || "Pending"}</td>
              </tr>
            </table>
          </div>

          <!-- Buttons Section -->
          <div style="text-align: center; margin-top: 28px;">
            <a href="${waLink}" target="_blank" style="display: inline-block; background-color: #25D366; color: #ffffff; text-decoration: none; padding: 12px 24px; border-radius: 50px; font-weight: bold; font-size: 14px; margin: 6px; box-shadow: 0 4px 12px rgba(37,211,102,0.3);">
              💬 Connect on WhatsApp
            </a>
            <a href="${WEBSITE_URL}" target="_blank" style="display: inline-block; background-color: #1C2430; color: #ffffff; text-decoration: none; padding: 12px 24px; border-radius: 50px; font-weight: bold; font-size: 14px; margin: 6px;">
              🌐 Visit Woofsy Website
            </a>
          </div>

        </div>

        <!-- Footer -->
        <div style="background-color: #F8FAFC; padding: 20px; text-align: center; border-top: 1px solid #E2E8F0; font-size: 12px; color: #94A3B8;">
          <p style="margin: 0 0 4px 0;">Woofsy Pet Care - Premium Groomers at Your Doorstep</p>
          <p style="margin: 0;"><a href="${WEBSITE_URL}" style="color: #FF8A3D; text-decoration: none;">${WEBSITE_URL}</a> | Contact: info@woofsy.co.in</p>
        </div>

      </div>
    </div>
  `;
}

export function buildStatusUpdateEmailTemplate(booking, newStatus) {
  const waText = encodeURIComponent(`Hi Woofsy Team, updating regarding Booking status for ${booking.pet_name} (${newStatus})`);
  const waLink = `https://api.whatsapp.com/send/?phone=${WHATSAPP_NUM}&text=${waText}&type=phone_number&app_absent=0`;

  return `
    <div style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; background-color: #FFF8F2; padding: 20px; color: #1C2430;">
      <div style="max-width: 600px; margin: 0 auto; background: #ffffff; border-radius: 20px; overflow: hidden; box-shadow: 0 10px 25px rgba(0,0,0,0.05); border: 1px solid #FFEBE0;">
        
        <!-- Header -->
        <div style="background: linear-gradient(135deg, #FF8A3D 0%, #FF6B00 100%); padding: 24px; text-align: center; color: #ffffff;">
          <h1 style="margin: 0; font-size: 26px; font-weight: 800;">🐾 Woofsy Booking Update</h1>
        </div>

        <!-- Body Content -->
        <div style="padding: 32px 24px;">
          <h2 style="color: #FF8A3D; font-size: 20px; margin-top: 0;">
            Status Updated: <span style="color: #1C2430;">${newStatus}</span>
          </h2>
          <p style="font-size: 15px; line-height: 1.6; color: #4A5568;">
            Hi <b>${booking.owner_name}</b>, your grooming appointment for <b>${booking.pet_name}</b> status has been updated to <b>${newStatus}</b>.
          </p>

          <!-- Details Card -->
          <div style="background-color: #FFF8F2; border-radius: 14px; padding: 20px; margin: 24px 0;">
            <table style="width: 100%; border-collapse: collapse; font-size: 14px;">
              <tr>
                <td style="padding: 8px 0; color: #718096; font-weight: 600;">Pet Name:</td>
                <td style="padding: 8px 0; font-weight: bold; text-align: right; color: #1C2430;">${booking.pet_name}</td>
              </tr>
              <tr>
                <td style="padding: 8px 0; color: #718096; font-weight: 600;">Service:</td>
                <td style="padding: 8px 0; font-weight: bold; text-align: right; color: #FF8A3D;">${booking.service}</td>
              </tr>
              <tr>
                <td style="padding: 8px 0; color: #718096; font-weight: 600;">Date & Time:</td>
                <td style="padding: 8px 0; font-weight: bold; text-align: right; color: #1C2430;">${booking.preferred_date} (${booking.preferred_time})</td>
              </tr>
              <tr>
                <td style="padding: 8px 0; color: #718096; font-weight: 600;">Current Status:</td>
                <td style="padding: 8px 0; font-weight: 800; text-align: right; color: #2563EB;">${newStatus}</td>
              </tr>
            </table>
          </div>

          <!-- Buttons -->
          <div style="text-align: center; margin-top: 28px;">
            <a href="${waLink}" target="_blank" style="display: inline-block; background-color: #25D366; color: #ffffff; text-decoration: none; padding: 12px 24px; border-radius: 50px; font-weight: bold; font-size: 14px; margin: 6px;">
              💬 Chat with Support on WhatsApp
            </a>
            <a href="${WEBSITE_URL}" target="_blank" style="display: inline-block; background-color: #1C2430; color: #ffffff; text-decoration: none; padding: 12px 24px; border-radius: 50px; font-weight: bold; font-size: 14px; margin: 6px;">
              🌐 Visit Woofsy Website
            </a>
          </div>
        </div>

        <div style="background-color: #F8FAFC; padding: 20px; text-align: center; border-top: 1px solid #E2E8F0; font-size: 12px; color: #94A3B8;">
          <p style="margin: 0;">Woofsy Pet Care · <a href="${WEBSITE_URL}" style="color: #FF8A3D; text-decoration: none;">${WEBSITE_URL}</a></p>
        </div>
      </div>
    </div>
  `;
}
